import {
  invertStrokeColor
} from "./chunk-VI6WTKMV.js";

// src/icons/CheckmarkCircle.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function CheckmarkCircle({
  strokeWidth = "2",
  strokeLinecap = "round",
  strokeLinejoin = "round"
}) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 32 33",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("rect", { y: "0.5", width: "32", height: "32", rx: "16", fill: "currentColor" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M8 16.4995L13 21.4995L24 10.4995",
            className: invertStrokeColor,
            strokeWidth,
            strokeLinecap,
            strokeLinejoin
          }
        )
      ]
    }
  );
}

export {
  CheckmarkCircle
};
